// extracted by mini-css-extract-plugin
module.exports = {"Container":"BackLink_Container__qqFOi","Div":"BackLink_Div__bh236","Icon":"BackLink_Icon__QGebh","SVG":"BackLink_SVG__LvKQn"};